import { type CSSProperties, useContext } from "react";
import BlockIcon from "@mui/icons-material/Block";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import PushPinIcon from "@mui/icons-material/PushPin";
import { ContextProvider } from "../../../contextProvider";
import TripleDotPoperMenu from "../../../components/TripleDotPoperMenu/TripleDotPoperMenu";
import strings from "../../../strings";
import { formatDateTimeAgo } from "../../../utils/dateActions";
import ChatAvatars from "../ChatAvatars/ChatAvatars";
import s from "./ChatContactElement.module.css";

type ChatContactMenuItem = {
  title: string;
  action: () => void;
  disabled?: boolean;
  styles?: CSSProperties;
};

type ChatContactElementProps = {
  lastMessage: string | null;
  fullname?: string;
  title?: string;
  dateLastMessage: Date | null | undefined;
  unreadMessages: number;
  isSelectedChat: boolean;
  membersIds: string[];
  isAdminChat?: boolean;
  isPinned?: boolean;
  isMuted?: boolean;
  isBlocked?: boolean;
  menuItemData?: ChatContactMenuItem[];
};

const ChatContactElement = ({
  lastMessage,
  fullname,
  dateLastMessage,
  unreadMessages,
  isSelectedChat,
  membersIds,
  isAdminChat,
  title,
  isPinned = false,
  isMuted = false,
  isBlocked = false,
  menuItemData = [],
}: ChatContactElementProps) => {
  const { userData } = useContext(ContextProvider);

  return (
    <div className={`${s.container} ${isSelectedChat ? s.selectedChat : ""}`}>
      <div className={s.leftContactInfo}>
        <div style={{ marginRight: "10px" }}>
          <ChatAvatars userIds={membersIds} />
        </div>
        <div className={s.nameTitleBlock}>
          <div className={s.nameBlock}>
            <span>{title || fullname}</span>
            {isAdminChat && <span className={s.adminBadge}>support</span>}
            <div className={s.statusIndicators}>
              {isPinned && (
                <PushPinIcon
                  className={s.statusIcon}
                  fontSize="small"
                  titleAccess={strings.pinnedChats}
                />
              )}
              {isMuted && (
                <NotificationsOffIcon
                  className={s.statusIcon}
                  fontSize="small"
                  titleAccess={strings.muteChat}
                />
              )}
              {isBlocked && (
                <BlockIcon
                  className={s.statusIcon}
                  fontSize="small"
                  titleAccess={strings.chatBlocked}
                />
              )}
            </div>
          </div>
          <span className={s.lastMessage}>{lastMessage}</span>
        </div>
      </div>
      <div className={s.rightContactBlock}>
        {dateLastMessage && (
          <span>
            {formatDateTimeAgo(
              new Date(dateLastMessage),
              userData!.selectedLanguage,
            )}
          </span>
        )}
        {unreadMessages !== 0 && (
          <span className={s.newMessageIndicator}>{unreadMessages}</span>
        )}
        {menuItemData.length > 0 && (
          <div
            className={s.actionMenu}
            onClick={(event) => event.stopPropagation()}
            onKeyDown={(event) => event.stopPropagation()}
          >
            <TripleDotPoperMenu menuItemDta={menuItemData} />
          </div>
        )}
      </div>
      {isSelectedChat && <div className={s.selectIndicator}></div>}
    </div>
  );
};

export default ChatContactElement;
